import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractComment.List.IRequest;
type Response = Api.Core.ContractComment.List.IResponse;
type Headers = Api.Core.ContractComment.List.IHeaders;
const url = '/api/Sales/ContractComment';
export default async function contractCommentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
